<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" @keydown.enter="confirm" @keydown.esc="cancel" persistent max-width="300" scrollable>
      <v-card>
        <v-card-text justify-center>
          <p class="text-md-center">{{confirmation}}</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn id="confirm_confirm" class="mx-0" :loading="loading" flat color="primary" @click.native="confirm">{{buttonConfirm}}</v-btn>
          <v-btn id="confirm_cancel" class="mx-0" flat @click.native="cancel" :loading="loading">{{buttonCancel}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>

</template>

<script>
  export default {
    name: 'confirm',
    data: () => ({
      loading: false
    }),
    props: {
      text: {
        type: String
      },
      dialog: {
        type: Boolean,
        default: false
      },
      buttonConfirm: {
        type: String,
        default: 'Confirmar'
      },
      buttonCancel: {
        type: String,
        default: 'Cancelar'
      },
      entity: {
        type: String,
        default: 'none'
      }
    },
    methods: {
      confirm () {
        this.loading = true
        this.$emit('confirm')
        setTimeout(() => {
          this.loading = false
        }, 500)
      },
      cancel () {
        this.$emit('cancel')
      }
    },
    computed: {
      confirmation: function () {
        if (this.entity === 'none') {
          return this.text + '?'
        } else {
          return this.text + this.entity + '?'
        }
      }
    }
  }
</script>

<style scoped>
  p {
    margin-bottom: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/PConfirm.vue